import { useEffect, useState } from 'react'

export function useOS() {
  const [os, setOS] = useState<'ios' | 'android'>('ios')

  useEffect(() => {
    const ua = navigator.userAgent
    if (/android/i.test(ua)) {
      setOS('android')
    }
  }, [])

  return os
}
